import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from '../../../_models/field.interface';
@Component({
  selector: 'app-checkboxCustom',
  template: `
    <div
      [ngClass]="field.class != null ? field.class : ''"
      [formGroup]="group"
      [ngStyle]="field.styleDivPrincipal ? field.styleDivPrincipal() : null"
      [hidden]="field.visible != null ? (!field.visible ? 'hidden' : '') : ''">
      <mat-checkbox  [(ngModel)]="item.value.checked"
      [ngModelOptions]="{standalone: true}" [checked]="item.value.checked" *ngFor="let item of field.multiOptions" [value]="item.value.descricao" (change)="field.change ? field.change($event) : null" [ngStyle]="field.style ? field.style() : null" [style]="item.value.textoLivre ? 'margin-bottom: 10px;' : 'margin-bottom: 0px;'">
      <label [ngStyle]="field.styleLabelCheckBox ? field.styleLabelCheckBox() : null" class="cs_label" [innerHTML]="item.value.descricao | linkify"></label>

      <div style="display: flex; position: absolute;" [hidden]="!item.value.textoLivre">
        <textarea type="text" [ngClass]="item.value.checked ? 'lovers-input' : 'lovers-input lovers-input-disabled'" [ngModelOptions]="{standalone: true}" [disabled]="!item.value.checked" [id]="item.value.descricao" [(ngModel)]="item.value.valor" (change)="field.change ? field.change($event) : null"></textarea>
      </div>

      </mat-checkbox>
    </div>
  `,
  styles: [`
  ::root {
    --opacity: 0;
  }

  .lovers-input {
    width: 300px;
    height: 51px;
    border-radius: 16px;
    outline: none;
    transition: 0.3s;
    padding-left: 5px;
    border: 2px solid transparent;
    resize: none;
    margin: -5px 0 0px 0;
    padding: 5px 10px 5px 10px;
    line-height: 18px;

    background: #ffffff;
    border: 1px solid #dfcecb;
    color: var(--text-color-paquera);
  }

  .lovers-input:focus {
    outline: 0;
    border: 2px solid #ff5c3e;
    box-shadow: 5px 10px 38px rgba(30, 30, 30, 0.1);
  }

  .lovers-input-disabled {    color: rgba(176, 176, 176, 0.79);    cursor: default !important;  }

  mat-checkbox ::ng-deep .mat-checkbox-inner-container { opacity: var(--opacity);}`],
})
export class CheckboxCustomComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  constructor() {}
  ngOnInit() {}
}
